export default __webpack_public_path__ + "static/media/instructions.4dac81cc.svg";